
export const LOADING = "LOADING";
export const LOADED = "LOADED";

export const GET_ALL_COMMUNITY_LIST = "GET_ALL_COMMUNITY_LIST";

export const GET_ALL__GROUP_BY_COMMUNITY_ID = "GET_ALL__GROUP_BY_COMMUNITY_ID";